import React, { useState, useEffect, useContext } from "react";

import FormSectionLayout from "../../layouts/FormSectionLayout";
import HeadingText from "../../common/HeadingText/HeadingText";
import { Container, Form, Row, Col, Spinner } from "reactstrap";
import "./AddUpdatePromosCityLevelPage.scss";
import ButtonComponent from "../../common/Button/ButtonComponent";

import { IAddBulkPromosCityLevelPageProps } from "../../../interfaces/Index";
import LoaderComponent from "../../common/Loader/Loader";
import { _ } from "../../../utils/lib";
import { AbilityContext } from "../../../config/Can";
import {
  NEW_BULK_PROMO,
  CREATE_BULK_PROMO,
} from "./constants/PromosCityLevelConstants";
import { SelectDropDown } from "../../common/SelectDropDown/SelectDropDown";
import { acceptableFormats } from "config/constants";
import UploadButtonComponent from "../../common/UploadButton/UploadButtonComponent";
import backArrow from "assets/images/back_arrow.svg";
import { IAddUserLevelBulkPromoState } from "interfaces/userLevelPromo.interface";
import {
  PromoOptions,
  PromoType,
} from "./constants/AddBulkPromosCityLevelConstats";

const AddBulkPromosCityLevelPage: React.FunctionComponent<
  IAddBulkPromosCityLevelPageProps
> = (props) => {
  const ability = useContext(AbilityContext);
  const [selectedPromoType, setSelectedPromoType] = useState<PromoType>(
    PromoOptions[3].id as PromoType
  );

  const [userLevelPromoState, setUserLevelPromoState] =
    useState<IAddUserLevelBulkPromoState>({
      promoDetailsCsvFile: null,
      promoDetailsCsvFileName: "",
      userIdsCsvFile: null,
      userIdsCsvFileName: "",
    });

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
    }
  }, [props.isError]);

  useEffect(() => {
    const { isPromoAdded, backButtonHandler, clearPromoDetails } = props;
    if (isPromoAdded) {
      backButtonHandler(true);
      setTimeout(() => {
        clearPromoDetails();
      }, 100);
    }
  }, [props.isPromoAdded]);

  const headingText = NEW_BULK_PROMO;

  const buttonText = CREATE_BULK_PROMO;

  const handleGoBackButton = () => {
    const { clearPromoDetails, backButtonHandler, selectedCity } = props;
    clearPromoDetails();
    backButtonHandler(false, selectedCity);
  };

  const handleSubmit = () => {
    const { createUserLevelPromoBulk } = props;
    const { promoDetailsCsvFile, userIdsCsvFile } = userLevelPromoState;

    if (userIdsCsvFile && promoDetailsCsvFile) {
      const formData = new FormData();
      formData.append("promoIdsFile", promoDetailsCsvFile);
      formData.append("usersIdsFile", userIdsCsvFile);
      createUserLevelPromoBulk(formData, selectedPromoType);
    }
  };

  const handlePromoDetailsCSVInputChange = (file: any) => {
    if (file) {
      setUserLevelPromoState({
        ...userLevelPromoState,
        promoDetailsCsvFile: file,
        promoDetailsCsvFileName: file.name,
      });
    }
  };

  const handlePromoDetailsCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setUserLevelPromoState({
      ...userLevelPromoState,
      promoDetailsCsvFile: null,
      promoDetailsCsvFileName: "",
    });
  };

  const handleUserIdsCSVInputChange = (file: any) => {
    if (file) {
      setUserLevelPromoState({
        ...userLevelPromoState,
        userIdsCsvFile: file,
        userIdsCsvFileName: file.name,
      });
    }
  };

  const handleUserIdsCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setUserLevelPromoState({
      ...userLevelPromoState,
      userIdsCsvFile: null,
      userIdsCsvFileName: "",
    });
  };

  const renderPromoDetail = () => {
    return (
      <FormSectionLayout subTitleText="Promo details">
        <div className="form-row">
          <Col>
            <SelectDropDown
              label="Type"
              disabled={true}
              options={PromoOptions}
              id="promoType"
              handleChange={(e) => {
                console.log("value");
              }}
              value={selectedPromoType}
              defaultOption={{
                id: "-1",
                value: "Select promo type",
                text: "Select promo type",
              }}
            />
          </Col>
        </div>
      </FormSectionLayout>
    );
  };

  const renderPromoDetailsCSV = () => (
    <div className="user-level-upload-component-container-wrapper bulk-upload-container">
      <Row>
        <Col lg="6">
          <UploadButtonComponent
            id="upload-promo-details-csv"
            buttonText={
              userLevelPromoState.promoDetailsCsvFile
                ? userLevelPromoState.promoDetailsCsvFileName
                : "Upload .CSV "
            }
            fileFormat={acceptableFormats.csv}
            fileUploaded={!!userLevelPromoState.promoDetailsCsvFile}
            handleRemoveFile={handlePromoDetailsCSVRemove}
            handleFileChange={handlePromoDetailsCSVInputChange}
            classes="large-button btn-primary promo-upload-btn"
          />
        </Col>
      </Row>
      <div className="btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-between align-items-center">
        <a
          href={require("../../../assets/static/bulk-promo-details-sample.csv")}
          target="_blank"
          className=""
        >
          <small>Download Sample </small>
        </a>
      </div>
    </div>
  );

  const renderUserIdsCSV = () => (
    <div className="user-level-upload-component-container-wrapper bulk-upload-container">
      <Row>
        <Col lg="6">
          <UploadButtonComponent
            id="upload-user-ids-csv"
            buttonText={
              userLevelPromoState.userIdsCsvFile
                ? userLevelPromoState.userIdsCsvFileName
                : "Upload .CSV "
            }
            fileFormat={acceptableFormats.csv}
            fileUploaded={!!userLevelPromoState.userIdsCsvFile}
            handleRemoveFile={handleUserIdsCSVRemove}
            handleFileChange={handleUserIdsCSVInputChange}
            classes="large-button btn-primary promo-upload-btn"
          />
        </Col>
      </Row>
      <div className="btn-primary-outline button-large btn btn-secondary no-border-btn d-flex justify-content-between align-items-center">
        <a
          href={require("../../../assets/static/bulk-user-ids-samples.csv")}
          target="_blank"
          className=""
        >
          <small>Download Sample </small>
        </a>
      </div>
    </div>
  );
  // const renderError = () => {
  //   if (
  //     props.isUserLevelPromoCsvError &&
  //     userLevelPromoState.isUserLevelPromoCsvUploaded &&
  //     showUserLevelModal
  //   ) {
  //     return (
  //       <Modal
  //         modalHeading="User Level CSV"
  //         showModal={showUserLevelModal}
  //         closeModalHandler={() =>
  //           closeUserLevelModal(setIsShowUserLevelModal, showUserLevelModal)
  //         }
  //         isSuccess={
  //           props.isUserLevelPromoCsvUploaded && !props.isUserLevelPromoCsvError
  //             ? true
  //             : false
  //         }
  //         failedRecords={props.isUserLevelPromoCsvError ? "" : ""}
  //         modalBodyClass="batch-modal"
  //         showProgressString={false}
  //       >
  //         {props.isUserLevelPromoCsvError ? (
  //           <div className="py-3">
  //             <section className="upload-error">
  //               <img src={warning} />
  //               <div className="title">Upload failed</div>
  //             </section>

  //             {props.isUserLevelPromoCsvError && (
  //               <div className="desc">
  //                 {props.isUserLevelPromoCsvError &&
  //                   (props.isUserLevelPromoCsvError! as any).errors.map(
  //                     (e: String[]) => {
  //                       return <div className="format-msg-style">{e}</div>;
  //                     }
  //                   )}
  //               </div>
  //             )}
  //           </div>
  //         ) : null}
  //       </Modal>
  //     );
  //   }
  // };

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row id="addEditButtonRow" className="add-update-button-container">
          <Col lg="6">
            <ButtonComponent
              buttonClass="large-button btn-primary"
              buttonText={buttonText}
              onClickHandler={handleSubmit}
              isDisable={
                props.isLoading ||
                !userLevelPromoState.promoDetailsCsvFile ||
                !userLevelPromoState.userIdsCsvFile
              }
            />
          </Col>
        </Row>
      </div>
    );
  };

  //main control of return UI
  return (
    <Container fluid>
      {props.isLoading && <LoaderComponent />}
      <Row>
        <Col lg="5">
          <div className="back-button">
            <a href="javascript:void(0)" onClick={handleGoBackButton}>
              {" "}
              {/* TO-DO: Convert this to a button in all compoents. */}
              <span>
                <img src={backArrow} alt="close" />
              </span>{" "}
              Back to Promos
            </a>
          </div>
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="promos-detail">{renderPromoDetail()}</div>
            <div className="promo-criteria form-row-separator">
              <FormSectionLayout subTitleText="Promo Details CSV">
                {renderPromoDetailsCSV()}
              </FormSectionLayout>
            </div>
            <div className="promo-criteria form-row-separator">
              <FormSectionLayout subTitleText="User ID CSV">
                {renderUserIdsCSV()}
                {renderFormButton()}
              </FormSectionLayout>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AddBulkPromosCityLevelPage;
